"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ContextVarsEditor = void 0;
const React = __importStar(require("react"));
const uuid_1 = require("uuid");
const propertyEditors_1 = require("../widgets/propertyEditors");
const localization_1 = require("../widgets/localization");
const bootstrap_1 = require("@mwater/react-library/lib/bootstrap");
const ListEditorComponent_1 = require("@mwater/react-library/lib/ListEditorComponent");
const contextVarValues_1 = require("../contextVarValues");
const immer_1 = __importDefault(require("immer"));
/** Edits a set of context variables and their values */
const ContextVarsEditor = (props) => {
    const renderItem = (boundContextVar, index) => {
        const contextVar = boundContextVar.contextVar;
        const value = boundContextVar.value;
        let desc = contextVar.type;
        if (contextVar.table) {
            desc += " of ";
            desc += props.schema.getTable(contextVar.table)
                ? (0, localization_1.localize)(props.schema.getTable(contextVar.table).name, "en")
                : contextVar.table;
        }
        return (React.createElement("div", null,
            React.createElement("div", null,
                contextVar.name,
                " ",
                React.createElement("span", { className: "text-muted" },
                    "- ",
                    desc)),
            React.createElement(contextVarValues_1.ContextVarValueEditor, { contextVar: contextVar, contextVarValue: value, onContextVarValueChange: (value) => {
                    props.onChange((0, immer_1.default)(props.boundContextVars, (draft) => {
                        if (value == null) {
                            delete draft[index].value;
                        }
                        else {
                            draft[index].value = value;
                        }
                    }));
                }, schema: props.schema, dataSource: props.dataSource, availContextVars: props.availContextVars })));
    };
    const renderEditor = (item, onItemChange) => {
        return React.createElement(ContextVarEditor, { contextVar: item.contextVar, onContextVarChange: (contextVar) => onItemChange({ contextVar, value: item.value }), schema: props.schema, locale: "en", allowEditingId: props.allowEditingId });
    };
    const validateItem = (boundContextVar) => {
        const contextVar = boundContextVar.contextVar;
        if (!contextVar || !contextVar.type) {
            alert("Type required");
            return false;
        }
        if (contextVar.type === "row" || contextVar.type === "rowset") {
            if (!contextVar.table) {
                alert("Table required");
                return false;
            }
        }
        return true;
    };
    return (React.createElement(ListEditorComponent_1.ListEditorComponent, { items: props.boundContextVars, onItemsChange: props.onChange, renderItem: renderItem, addLabel: "Add Variable", createNew: () => ({ contextVar: { id: (0, uuid_1.v4)(), name: "Untitled", type: "rowset" } }), renderEditor: renderEditor, validateItem: validateItem, deleteConfirmPrompt: "Delete variable?", editLink: true }));
};
exports.ContextVarsEditor = ContextVarsEditor;
function ContextVarEditor(props) {
    const mainTypeOptions = [
        { value: "row", label: "Single Row" },
        { value: "rowset", label: "Multiple Rows" },
        { value: "advanced", label: "Advanced..." }
    ];
    const advancedTypeOptions = [
        { value: "text", label: "Text" },
        { value: "number", label: "Number" },
        { value: "boolean", label: "Boolean" },
        { value: "enum", label: "Enum" },
        { value: "enumset", label: "Enum set" },
        { value: "id", label: "Reference" },
        { value: "id[]", label: "Reference List" },
        { value: "date", label: "Date" },
        { value: "datetime", label: "Datetime" },
        { value: "geometry", label: "Geometry" },
        { value: "image", label: "Image" },
        { value: "imagelist", label: "Image List" }
    ];
    return (React.createElement("div", { style: { paddingBottom: 200 } },
        props.allowEditingId ?
            React.createElement(propertyEditors_1.LabeledProperty, { label: "Id", hint: "Lower case with underscores only" },
                React.createElement(propertyEditors_1.PropertyEditor, { obj: props.contextVar, property: "id", onChange: props.onContextVarChange }, (value, onChange) => React.createElement(bootstrap_1.TextInput, { value: value || "", onChange: (id) => onChange(id || "") })))
            : null,
        React.createElement(propertyEditors_1.LabeledProperty, { label: "Name" },
            React.createElement(propertyEditors_1.PropertyEditor, { obj: props.contextVar, property: "name", onChange: props.onContextVarChange }, (value, onChange) => React.createElement(bootstrap_1.TextInput, { value: value || "", onChange: (name) => onChange(name || "") }))),
        React.createElement(propertyEditors_1.LabeledProperty, { label: "Type" },
            React.createElement(propertyEditors_1.PropertyEditor, { obj: props.contextVar, property: "type", onChange: props.onContextVarChange }, (value, onChange) => (React.createElement("div", null,
                React.createElement(bootstrap_1.Toggle, { value: value == "row" || value == "rowset" ? value : "advanced", onChange: (v) => onChange(v == "advanced" ? "text" : v), options: mainTypeOptions, size: "sm" }),
                value && value != "row" && value != "rowset" ? (React.createElement("div", { style: { padding: 5 } },
                    React.createElement(bootstrap_1.Select, { value: value, onChange: onChange, options: advancedTypeOptions }))) : null)))),
        props.contextVar.type == "enum" || props.contextVar.type == "enumset" ? (React.createElement(propertyEditors_1.LabeledProperty, { label: "Enum Options" },
            React.createElement(propertyEditors_1.PropertyEditor, { obj: props.contextVar, property: "enumValues", onChange: props.onContextVarChange }, (value, onChange) => React.createElement(EnumValuesEditor, { enumValues: value, onChange: onChange })))) : null,
        props.contextVar.type == "id" || props.contextVar.type == "id[]" ? (React.createElement(propertyEditors_1.LabeledProperty, { label: "Referenced Table" },
            React.createElement(propertyEditors_1.PropertyEditor, { obj: props.contextVar, property: "idTable", onChange: props.onContextVarChange }, (value, onChange) => (React.createElement(propertyEditors_1.TableSelect, { schema: props.schema, value: value || null, onChange: (t) => onChange(t || undefined), locale: props.locale }))))) : null,
        React.createElement(propertyEditors_1.LabeledProperty, { label: "Table", hint: props.contextVar.type != "row" && props.contextVar.type != "rowset" ? "Optional" : undefined },
            React.createElement(propertyEditors_1.PropertyEditor, { obj: props.contextVar, property: "table", onChange: props.onContextVarChange }, (value, onChange) => (React.createElement(propertyEditors_1.TableSelect, { schema: props.schema, value: value || null, onChange: (t) => onChange(t || undefined), locale: props.locale }))))));
}
/** Edits  */
function EnumValuesEditor(props) {
    function renderItem(enumValue, index, onEnumValueChange) {
        return (React.createElement("div", { style: { display: "grid", gridTemplateColumns: "1fr 2fr" } },
            React.createElement(bootstrap_1.TextInput, { value: enumValue.id, onChange: (id) => {
                    onEnumValueChange({ ...enumValue, id: id || "" });
                } }),
            React.createElement(propertyEditors_1.LocalizedTextPropertyEditor, { value: enumValue.name, onChange: (name) => {
                    onEnumValueChange({ ...enumValue, name: name });
                }, locale: "en" })));
    }
    return (React.createElement(ListEditorComponent_1.ListEditorComponent, { items: props.enumValues || [], onItemsChange: props.onChange, renderItem: renderItem, addLabel: "Add Enum Option", createNew: () => ({ id: "", name: { _base: "en", en: "" } }) }));
}
